import { getDomainEnv } from "@pathwright/ui/src/components/utils/env"
import Backbone from "backbone"
import Utils from "global/utils"
import { getAPIUrl } from "lib/core/api/urls"
import _ from "lodash"

window.Backbone = Backbone

class Application extends Backbone.Model {
  initialize() {
    this.utils = new Utils()
  }

  navigate(route, options, title = null, track) {
    if (options == null) {
      options = {}
    }
    if (track == null) {
      track = true
    }
    let navigationStore = window.App.getStore("navigation")
    return navigationStore.action.navigate(route, options, title)
  }

  getCurrentRoute() {
    let frag = Backbone.history.fragment
    if (_.isEmpty(frag)) {
      return null
    } else {
      return frag
    }
  }

  getAPIUrl(url) {
    url = getAPIUrl(url || "")
    // Only use https protocol in non-dev envs.
    const protocol = getDomainEnv(url) === "development" ? "http:" : "https:"
    return url.replace("http:", protocol)
  }
}

export default Application
